import React from 'react';
import { motion } from 'framer-motion';
import instagramLogo from '../assets/images/instagram-logo-svg0.svg'; 
import googleLogo from '../assets/images/g-100.svg';
import linkedinLogo from '../assets/images/linkedin-symbol-svg0.svg';
import xLogo from '../assets/images/group0.svg';
import ziplogyxLogo from '../assets/images/Labh Logo.png';
import texture from '../assets/images/background-image.jpg';

export const Footer = () => {
  return (
    <motion.footer
      className="relative w-full py-16 px-4"
      style={{
        backgroundImage: `url(${texture})`,
        backgroundColor: "#93A7AA",
        backgroundBlendMode: "overlay",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
    >
      <div className="max-w-[1440px] mx-auto flex flex-col gap-12">
        
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start gap-12 w-full">
          
          {/* Logo */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }} 
            whileInView={{ opacity: 1, scale: 1 }} 
            transition={{ duration: 0.5 }}
            className="flex flex-col items-center"
          >
            <img 
              className="w-full h-24 object-cover" 
              src={ziplogyxLogo} 
              alt="Ziplogyx Logo" 
              loading="lazy"
            />
          </motion.div>

          {/* Quick Links */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }} 
            whileInView={{ opacity: 1, x: 0 }} 
            transition={{ duration: 0.6 }}
            className="flex flex-col gap-4"
          >
            <h3 className="text-white text-left font-roboto font-medium text-[20px] uppercase">
              Quick Links
            </h3>
            <div className="flex flex-col gap-[14px]">
              {['Home', 'Services', 'About', 'Contact'].map((link, i) => (
                <a
                  key={i}
                  href={`/${link.toLowerCase()}`}
                  className="text-[#e0e0e0] font-roboto text-[20px] leading-[30px] hover:text-white hover:scale-105 transition duration-300"
                >
                  {link}
                </a>
              ))}
            </div>
          </motion.div>

          {/* Contact Info */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }} 
            whileInView={{ opacity: 1, x: 0 }} 
            transition={{ duration: 0.6, delay: 0.1 }}
            className="flex flex-col gap-4"
          >
            <h3 className="text-white font-roboto font-medium text-[20px] uppercase">
              Contact Info
            </h3>
            <div className="flex flex-col gap-[14px] max-w-[278.5px] text-[#e0e0e0] text-[20px] leading-[30px]">
              <p>+91 99095 01696</p>
              <p>amp@labhind.com</p>
              <p>
                Plot 221, Navi Jambuvai,<br />
                Near Ajwa Canal-Nimeta Village,<br />
                Taluka - Waghodia, Vadodara – 391760
              </p>
            </div>
          </motion.div>
        </div>

        {/* Divider */}
        <motion.hr 
          className="border-t-2 border-[#d69291] w-full"
          initial={{ width: 0 }}
          whileInView={{ width: "100%" }}
          transition={{ duration: 1 }}
        />

        {/* Bottom Section */}
        <motion.div 
          className="flex flex-col md:flex-row justify-between items-center gap-6 w-full"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-[#e0e0e0] font-roboto text-[16px] leading-[24px]">
            All Copyrights Reserved @2024 Labh Industries
          </p>

          {/* Social Media Icons */}
         
        </motion.div>
      </div>
    </motion.footer>
  );
};
